import React, { useEffect, useState } from 'react';

import { Droppable, DroppableProps } from 'react-beautiful-dnd';

// In react v18 with strict mode the droppable throws an error saying the id can't be
// found. This github issue for react-beautiful-dnd offers a workaround:
//   https://github.com/atlassian/react-beautiful-dnd/issues/2399
export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};
